import { MediaRoute } from '@/features/media/navigation/mediaRoute';
import { GalleryScreen } from '@/features/media/screens/GalleryScreen';
import { NavigationBar } from '@/navigation/components/navbar/NavigationBar';
import { AppStack } from '@/navigation/stacks/appStack';
import { NavBarType } from '@/navigation/types/navbar';

export const useMediaRouting = () => ({
  mediaScreens: [
    <AppStack.Screen
      key={MediaRoute.Gallery}
      name={MediaRoute.Gallery}
      component={GalleryScreen}
      options={{
        header: () => <NavigationBar type={NavBarType.MODAL_WITH_CLOSE} />,
        headerShown: true,
        presentation: 'containedModal',
        animation: 'fade'
      }}
    />
  ]
});
